/*
 * @Author: ymk
 * @Date: 2020-07-23 15:48:47
 * @LastEditors: ymk
 * @LastEditTime: 2020-07-28 19:26:11
 * @FilePath: \car-demo\src\router\ranking.js
 */
const rankingRoutes = [
	// {
    //     path: '/ranking',
    //     name: 'Ranking',
    //     component: () => import('../views/Ranking/index.vue'),
    //     redirect: '/ranking/instructor',
    //     children: [
    //         {// 教练红人榜
    //             path: 'instructor',
    //             name: 'Instructor',
    //             component: () => import('../views/Ranking/Instructor.vue')
    //         },
    //         {// 金牌打赏人
    //             path: 'customer',
    //             name: 'Customer',
    //             component: () => import('../views/Ranking/Customer.vue')
    //         }
    //     ]
    // },
    { // 打赏教练
        path: '/reward',
        name: 'Reward',
        component: () => import('../views/Ranking/Reward.vue')
    },
]

export default rankingRoutes;
